module.exports = __webpack_public_path__ + "img/dgm.b1211a54.png";